'use client';

import {
    Box,
    Button,
    Columns,
    ColumnsItem,
    IconName,
    Price,
    PriceLevel,
    Text,
    TrilogyColor,
    TypographyBold,
    View,
} from '@bytel/trilogy-react-ts';

import { RepeaterProduct } from '@app-types/product';

import { calculFinalPrice } from '@helpers/utils';

import { useHome } from '@landing/hooks';

import StickyItem from './sticky-item';

export default function StickySummary({
    mobileFirst,
    featureFaiBlockActivated,
    isStickyVisible,
    repeaters,
}: {
    mobileFirst: boolean;
    featureFaiBlockActivated: boolean;
    isStickyVisible: boolean;
    repeaters?: RepeaterProduct[];
}) {
    const { selectedFaiOption, selectedFaiProduct, selectedPlan, handleAddToCart, selectedNetwork } = useHome();
    const repeater = repeaters?.find((r) => r.gencode === selectedFaiProduct?.gencode_repeater);
    const bboxPrice = (selectedFaiProduct?.product.price || 0) + (selectedFaiProduct?.product.rental_fees || 0);
    const planPrice = calculFinalPrice(selectedNetwork, selectedPlan, selectedFaiProduct);
    const otisRepeaterPrice = selectedFaiOption && repeater ? repeater.prices.final : 0;
    return (
        <footer
            className='sticky-footer animated p-sticky'
            id='sticky-footer'
            style={{
                opacity: isStickyVisible ? 1 : 0,
                bottom: isStickyVisible ? 0 : -200,
            }}
        >
            <View className='sticky-container'>
                <Box>
                    <Columns verticalCentered>
                        <ColumnsItem>
                            <Columns verticalCentered>
                                <ColumnsItem narrow>
                                    <View className='has-text-right is-flex-mobile is-spaced-between'>
                                        <Text
                                            className='is-marginless is-hidden-tablet'
                                            typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                        >
                                            Votre sélection
                                        </Text>
                                        <Text className='is-hidden-mobile' typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                                            Votre sélection
                                        </Text>
                                        <View className='is-hidden-tablet is-hidden-desktop flex-1'>
                                            <Price
                                                amount={bboxPrice + planPrice + otisRepeaterPrice}
                                                showCents
                                                period='mois'
                                                className='mobile-sticky-price'
                                                inline
                                            />
                                        </View>
                                        <View className='is-hidden-mobile flex-1'>
                                            <Price
                                                level={PriceLevel.LEVEL4}
                                                amount={+(bboxPrice + planPrice + otisRepeaterPrice).toFixed(2)}
                                                showCents
                                                period='mois'
                                            />
                                        </View>
                                    </View>
                                </ColumnsItem>
                                <ColumnsItem>
                                    <View flexable className='is-vertical gap-small is-mobile'>
                                        <StickyItem
                                            iconName={IconName.SIM_CARD}
                                            offerType={selectedPlan?.name?.replace('Go', ' Go') || 'Forfait mobile'}
                                            price={planPrice}
                                            order={mobileFirst ? 0 : 2}
                                        />

                                        {featureFaiBlockActivated ? (
                                            <>
                                                <StickyItem
                                                    iconName={IconName.BOX}
                                                    offerType={selectedFaiProduct?.title || 'Offre fibre'}
                                                    price={bboxPrice}
                                                    noOfferLabel='Aucune box sélectionnée'
                                                    order={mobileFirst ? 1 : 0}
                                                >
                                                    {selectedFaiOption && selectedFaiProduct ? (
                                                        <StickyItem
                                                            iconName={IconName.BOX}
                                                            offerType={
                                                                selectedFaiProduct?.title_repeater || 'Répéteur WiFi'
                                                            }
                                                            price={repeater?.prices.final}
                                                            showCents={false}
                                                            titleBold={false}
                                                            promoLabel={repeater?.promoLabel}
                                                            hideIcon
                                                        />
                                                    ) : null}
                                                </StickyItem>
                                            </>
                                        ) : null}
                                    </View>
                                </ColumnsItem>
                            </Columns>
                        </ColumnsItem>
                        <ColumnsItem narrow>
                            <Button
                                data-testid='sticky-btn'
                                onClick={() => {
                                    handleAddToCart();
                                }}
                                variant={TrilogyColor.PRIMARY}
                            >
                                Continuer
                            </Button>
                        </ColumnsItem>
                    </Columns>
                </Box>
            </View>
        </footer>
    );
}
